import { getMiniHostAppCampaigns } from './getMiniHostAppCampaigns';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { getIsShadowMailbox } from 'mini-user-config/lib/getIsShadowMailbox';
import type { MiniHostAppCampaign } from '../schema/MiniHostAppCampaign';

/**
 * Checks if the target campaign is allowed by the host app.
 * @param targetCampaign Campaign to be checked.
 */
export const isMiniHostAppCampaignEnabled = (targetCampaign: MiniHostAppCampaign): boolean => {
    if (!isMiniHostAppFeatureEnabled('campaigns')) {
        return false;
    }

    const hostAppCampaigns = getMiniHostAppCampaigns(getIsShadowMailbox());
    if (!hostAppCampaigns) {
        // Defaults to true since the 'campaigns' feature is enabled in host app.
        return true;
    }
    return hostAppCampaigns.includes(targetCampaign);
};
